import RPMPatientSearch from './rpm-patient-search'

export default RPMPatientSearch;
